import type { IChangeFilterItems } from "app/components/filters-bar/change-filter/ChangeFilter";
import { EChangeFilterValues } from "app/components/filters-bar/change-filter/ChangeFilter";

export const MAX_NUMBER_OF_ROWS = 5;
export const TABLE_COLUMN_KEYWORD = "Keyword";
export const TABLE_COLUMN_SHARE = "Share";
export const TABLE_COLUMN_CLICKS_CHANGE = "ClicksChange";
export const TABLE_COLUMN_WINDOW_VOLUME = "KwWindowVolume";
export const TABLE_COLUMN_VOLUME = "KwVolume";
export const TABLE_COLUMN_TOP_URL = "Url";
export const TABLE_COLUMN_CLICKS = "Clicks";

export const WIDGET_TITLE_KEY = "website.analysis.seo.overview.page.top_organic_keywords.title";
export const WIDGET_TOOLTIP_KEY = "website.analysis.seo.overview.page.top_organic_keywords.tooltip";
export const WIDGET_PAGES_TITLE_KEY = "website.analysis.seo.overview.page.top_organic_pages.title";
export const WIDGET_PAGES_TOOLTIP_KEY = "website.analysis.seo.overview.page.top_organic_pages.tooltip";
export const WIDGET_FOOTER_KEYWORDS_LINK_TEXT =
    "website.analysis.seo.overview.page.top_organic_keywords.footer.btn.title";
export const WIDGET_FOOTER_PAGES_LINK_TEXT = "website.analysis.seo.overview.page.top_organic_pages.footer.btn.title";
const WEBSITE_KEYWORDS_CONTROLLER = "/widgetApi/WebsiteAnalysisV2/WebsiteAnalysis";
export const SERVER_API = `${WEBSITE_KEYWORDS_CONTROLLER}/Table`;

export const changeFilterItems: IChangeFilterItems[] = [
    {
        text: "change.filter.all",
        id: EChangeFilterValues.All,
        tooltip: "change.filter.all.tooltip",
    },
    {
        text: "change.filter.new",
        id: EChangeFilterValues.NewClicks,
        tooltip: "change.filter.new.tooltip",
    },
    {
        text: "change.filter.lost",
        id: EChangeFilterValues.LostClicks,
        tooltip: "change.filter.lost.tooltip",
    },
    {
        text: "change.filter.trending",
        id: EChangeFilterValues.Trending,
        tooltip: "change.filter.trending.tooltip",
    },
    {
        text: "change.filter.de-trending",
        id: EChangeFilterValues.DeTrending,
        tooltip: "change.filter.detrending.tooltip",
    },
];
